import { api, resetToken } from '@/lib/api';
import { AuthResponse } from '@/types';

export class AuthService {
  static async getCurrentUser(): Promise<AuthResponse> {
    const response = await api.get<AuthResponse>('/auth');
    return response.data;
  }

  static async logout(): Promise<void> {
    await api.post('/logout');
    resetToken();
  }

  static async login(credentials: { email: string; password: string }): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/login', credentials);
    return response.data;
  }

  static async register(userData: { 
    email: string; 
    password: string; 
    name?: string; 
  }): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/register', userData);
    return response.data;
  }
}